import React, { useMemo } from "react";
import { useTheme } from "@emotion/react";
import S from "./ReplyMessage.styled";
import Close from "../../assets/icons/Close";
import { useChannel, useTranslation } from "../../hooks";
const ReplyMessage = ({ message, hasCloseBtn = false, }) => {
    const channel = useChannel();
    const strings = useTranslation();
    const theme = useTheme();
    const sender = useMemo(() => {
        const s = (message === null || message === void 0 ? void 0 : message.sender.id) === channel.currentUserId
            ? strings.currentSender
            : message === null || message === void 0 ? void 0 : message.sender.name.split(" ")[0];
        return s;
    }, [message, channel.currentUserId, strings.currentSender]);
    return (React.createElement(React.Fragment, null, message ? (React.createElement(S.ReplyWrapper, { hasCloseBtn: hasCloseBtn, theme: theme },
        React.createElement(S.ReplyInnerWrapper, { hasCloseBtn: hasCloseBtn, theme: theme },
            React.createElement(S.ReplySender, null, sender),
            React.createElement(S.ReplyText, { hasCloseBtn: hasCloseBtn },
                message.text,
                message.edited ? React.createElement(S.Span, null, "(edited)") : ""),
            hasCloseBtn && (React.createElement(S.CloseWrapper, { onClick: () => {
                    channel.setReplyMessage(null);
                } },
                React.createElement(Close, { fill: theme.color.backgroundBrand })))))) : null));
};
export default ReplyMessage;
//# sourceMappingURL=ReplyMessage.js.map